import React, { useMemo, useState } from 'react';

/**
 * Lightweight grid/table for the Sheets hub.
 * - column: { key, header, widthClass?, render?(row), getValue?(row) }
 */
export default function DizeeTable({
  columns,
  rows,
  rowKey,
  emptyTitle = 'No rows yet',
  emptyBody = 'When your apps create data, it will show up here.'
}) {
  const [query, setQuery] = useState('');

  const safeRows = Array.isArray(rows) ? rows : [];

  const filtered = useMemo(() => {
    if (!query.trim()) return safeRows;
    const q = query.toLowerCase();
    return safeRows.filter((r) => {
      try {
        return columns.some((c) => {
          const v = c.getValue ? c.getValue(r) : r?.[c.key];
          if (v === null || v === undefined) return false;
          return String(v).toLowerCase().includes(q);
        });
      } catch (e) {
        return false;
      }
    });
  }, [safeRows, query, columns]);

  return (
    <div>
      <div className="flex gap-2 mb-3">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search…"
          className="flex-1 bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg px-3 py-2 text-white text-[12px] placeholder-[rgba(255,255,255,0.3)] focus:outline-none focus:border-[rgba(255,255,255,0.25)]"
        />
        <div className="px-3 py-2 rounded-lg text-[11px] border bg-[rgba(255,255,255,0.03)] border-[rgba(255,255,255,0.08)] text-white opacity-70">
          {filtered.length}
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="p-4 bg-black border border-[rgba(255,255,255,0.08)] rounded-lg">
          <p className="text-white text-[12px] font-medium">{emptyTitle}</p>
          <p className="text-white text-[11px] opacity-60 mt-1">{emptyBody}</p>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-[rgba(255,255,255,0.08)]">
          <table className="min-w-full bg-black">
            <thead>
              <tr className="border-b border-[rgba(255,255,255,0.08)]">
                {columns.map((c) => (
                  <th
                    key={c.key}
                    className={[
                      'text-left text-[10px] font-medium text-white opacity-60 px-3 py-2 whitespace-nowrap',
                      c.widthClass || ''
                    ].join(' ')}
                  >
                    {c.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, idx) => (
                <tr
                  key={rowKey ? rowKey(r) : r?._id || r?.id || idx}
                  className="border-b border-[rgba(255,255,255,0.06)] last:border-b-0 hover:bg-[rgba(255,255,255,0.03)]"
                >
                  {columns.map((c) => (
                    <td key={c.key} className="px-3 py-2 text-[11px] text-white whitespace-nowrap">
                      {c.render ? c.render(r) : String((c.getValue ? c.getValue(r) : r?.[c.key]) ?? '')}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


